// 解决方案管理
import http from "@/jslibs/axios/http";

// 新增解决方案
export const add = (data) => http.post("/cms/solution/add", data);

// 编辑解决方案
export const edit = (data) => http.post("/cms/solution/update", data);

// 解决方案详情
export const detail = (id) => http.get("/cms/solution/details/" + id);

// 解决方案分页列表
export const page = (data) => http.get("/cms/solution/page", data);

// 解决方案分类全量列表
export const categoryList = (data) => http.get("/cms/solution/category/list", data);

// 解决方案上下架
export const update = (data) => http.post("/cms/solution/updateShelfStatus", data);

// 解决方案审核
export const approve = (data) => http.post("/cms/solution/approve", data);
